<template>
  <div>
    <div class="bread-crumbs-box">
      <Breadcrumb separator="»" class="bread-crumbs container">
        <Breadcrumb-item class="breadcrumb-item" to="/">首页</Breadcrumb-item>
        <Breadcrumb-item
          v-if="!articleInfo.parentId"
          class="breadcrumb-item"
          to="/news"
          >新闻资讯</Breadcrumb-item
        >
        <Breadcrumb-item
          v-else
          class="breadcrumb-item"
          :to="'/news/' + articleInfo.parentId"
          >{{ articleInfo.parentCategoryName }}</Breadcrumb-item
        >
        <Breadcrumb-item class="breadcrumb-item-last">{{
          articleInfo.categoryName
        }}</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="container am-cf">
      <div class="am-fl article-main am-margin-bottom">
        <h1 class="am-text-lg am-text-center am-margin-bottom">
          {{ articleInfo.title }}
        </h1>
        <div class="article-main-info" v-html="articleInfo.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { article } from "../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      articleInfo: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      const id = this.$route.params.id;
      if (!id) return;
      article.getArticleInfo(id).then((res) => {
        //console.log(res);
        if (res.status === 1) {
          this.articleInfo = res.data;
          this.setMetaData(this.articleInfo.title);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bread-crumbs-box {
  background: #fff;
  margin-bottom: 32px;
  .bread-crumbs {
    height: 48px;
    line-height: 48px;
    background: #fff;
    .breadcrumb-item {
      color: #0e90d2;
      font-size: 15px;
    }
    .breadcrumb-item-last {
      color: #999;
      font-size: 15px;
    }
  }
}
.article-main-info {
  /deep/img {
    display: inline-block;
  }
  /deep/table {
    border-collapse: collapse;
    border: 1px solid #ccc;
    td {
      border: 1px solid #ccc;
    }
  }
}
.am-text-center {
  text-align: center;
}
.am-text-lg {
  font-size: 1.8rem;
}
.am-margin-bottom {
  margin-bottom: 1.6rem;
}
</style>
